function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.589 5.075a1914.06 1914.06 0 01260 1.79",
  fill: "none",
  stroke: "currentcolor",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.197 8.473"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNjMuMTk3IDguNDczIj4KICA8cGF0aCBkPSJNMS41ODkgNS4wNzVhMTkxNC4wNiAxOTE0LjA2IDAgMDEyNjAgMS43OSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4=";
export { SvgLine as ReactComponent };